import React, {Component} from 'react'

import TreeList from './SelectFolderDialog/TreeList'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

/**
 * <SelectFoldertDialog folders disableFolder onSelectFolder = {folder} onCancel = {}/>
 */

class SelectFoldertDialog extends Component {

	state = {
		selected: undefined
	}

	constructor(props) {
		super(props)
		this.handleClickFolder = this.handleClickFolder.bind(this)
	}

	handleClickFolder(folder) {
		if (this.state.selected ? (this.state.selected.id === folder.id): false) {
			if (folder.type.toString() === "0") {
				folder.expand = !folder.expand
				this.forceUpdate()
			}
		} else {
			this.setState({
				selected: folder
			})
		}
	}

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
			onClick = {e => {
				e.stopPropagation()
				this.setState({
					selected: undefined
				})
			}}
		>

			<DialogTitle>
				Выбрать папку
			</DialogTitle>

			<DialogContent>

				<TreeList
					items = {this.props.items}
					selected = {this.state.selected}
					hideItems
					disableFolder = {this.props.disableFolder}
					onClickItem = {this.handleClickFolder}
				/>

			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSelectFolder === "function") {
							this.props.onSelectFolder(this.state.selected ? this.state.selected : {
								id: "0",
								type: "0",
								name: "root",
								items: this.props.items,
							})
						}
					}}
				>Выбрать</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default SelectFoldertDialog
